import { useState, useCallback, useRef, useMemo } from 'react';
import PROCESS_STATUS from './PROCESS_STATUS';

export default function useProcessItems() {
  const [status, setStatus] = useState(PROCESS_STATUS.IDLE);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState(null);
  const cancelRef = useRef(false);

  const beginProcessing = useCallback(() => {
    setStatus(PROCESS_STATUS.PROCESSING);
    setCurrentIndex(0);
    setError(null);
    cancelRef.current = false;
  }, []);

  const complete = useCallback(() => setStatus(PROCESS_STATUS.COMPLETE), []);

  const fail = useCallback(message => {
    setError(message);
    setStatus(PROCESS_STATUS.ERROR);
  }, []);

  const reset = useCallback(() => {
    setStatus(PROCESS_STATUS.IDLE);
    setCurrentIndex(0);
    setError(null);
  }, []);

  const cancel = useCallback(() => {
    cancelRef.current = true;
  }, []);

  const isProcessing = useMemo(() => status === PROCESS_STATUS.PROCESSING, [status]);

  const shouldCancel = useCallback(() => cancelRef.current, []);

  return {
    status,
    currentIndex,
    error,
    isProcessing,
    setCurrentIndex,
    shouldCancel,
    beginProcessing,
    complete,
    fail,
    reset,
    cancel,
  };
}
